
import React from "react";
import { Button } from "@/components/ui/button";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";

interface DevToolsSectionProps {
  hasBypass: boolean;
  onSetDevBypass: () => void;
  onRemoveDevBypass: () => void;
}

const DevToolsSection: React.FC<DevToolsSectionProps> = ({ hasBypass, onSetDevBypass, onRemoveDevBypass }) => {
  return (
    <section className="border-t pt-4 mt-4">
      <div className="flex items-center mb-2">
        <Info className="h-4 w-4 text-blue-500 mr-1" />
        <h3 className="text-lg font-medium">Development Tools</h3>
      </div>
      <p className="text-sm text-gray-500 mb-4">For local development only:</p>
      
      <div className="flex gap-2">
        {hasBypass ? (
          <Button variant="destructive" onClick={onRemoveDevBypass}>
            Remove Admin Bypass
          </Button>
        ) : (
          <Button variant="outline" onClick={onSetDevBypass}>
            Enable Admin Bypass for Development
          </Button>
        )}
      </div>
      
      {hasBypass && (
        <div className="mt-2">
          <Alert className="bg-yellow-50 border-yellow-200">
            <AlertTitle className="text-yellow-800">Admin Bypass Active</AlertTitle>
            <AlertDescription className="text-yellow-700">
              Admin verification is currently bypassed for development. This only works in development environments.
            </AlertDescription>
          </Alert>
        </div>
      )}
    </section>
  );
};

export default DevToolsSection;
